// Pure helpers for Configuraciones → Empaque. No React, no axios.
export const PACKING_AUDIT_KEY = 'packing_audit_percentage'
export const PACKING_CATEGORY = 'packing'

// Whole numbers 0..100 only; the error is a key under packing_config.audit.errors.
export const parsePercent = raw => {
  const text = raw === null || raw === undefined ? '' : String(raw).trim()
  if (text === '') return { error: 'required' }
  if (!/^\d+$/.test(text)) return { error: 'integer' }
  const value = Number(text)
  if (value > 100) return { error: 'max' }
  return { value }
}

// The card's three counters.
export const summarize = (storesCount, overrides) => {
  const excluded = overrides.filter(override => override.value === 0).length
  return {
    following: Math.max(storesCount - overrides.length, 0),
    exceptions: overrides.length - excluded,
    excluded,
  }
}

// 400/403/404 come flat ({ error, code }); 409/422 nested ({ error: { message, code } }).
export const configErrorCode = error => {
  const data = error?.response?.data
  if (!data) return null
  if (data.error && typeof data.error === 'object') return data.error.code || null
  return data.code || null
}

export const KNOWN_ERROR_CODES = ['forbidden', 'invalid_value', 'store_not_in_warehouse', 'store_spans_multiple_warehouses', 'concurrent_update', 'not_found']

export const mapConfigError = (error, fallback = 'generic') => {
  const code = configErrorCode(error)
  return `packing_config.audit.errors.${KNOWN_ERROR_CODES.includes(code) ? code : fallback}`
}

// A 404 on GET configurations: the platform does not ship the endpoint yet.
export const isNotAvailable = error => error?.response?.status === 404

export const packingConfigurations = data => (data?.configurations || []).filter(config => config.category === PACKING_CATEGORY)

// A store row wins whenever it exists; the platform reads a legacy NULL value as 0 (excluded).
export const normalizeOverrides = data => (data?.store_overrides || []).map(row => ({ ...row, value: row.value ?? 0 }))

// The platform sorts rows by transliterated, lower-cased store name, then store id. A base-sensitivity
// localeCompare is close enough for a seeded row; the background refetch settles the exact order.
const byStoreName = (a, b) =>
  String(a.store_name ?? '').localeCompare(String(b.store_name ?? ''), undefined, { sensitivity: 'base' }) || a.store_id - b.store_id

// Seeds the cached GET payload with a write's response row: replaces the row with the same store, or
// inserts it in order. Nothing to seed before the list has loaded once.
export const withOverrideRow = (data, row) => {
  if (!data) return data
  const rows = (data.store_overrides || []).filter(existing => existing.store_id !== row.store_id)
  const at = rows.findIndex(existing => byStoreName(row, existing) < 0)
  return { ...data, store_overrides: at === -1 ? [...rows, row] : [...rows.slice(0, at), row, ...rows.slice(at)] }
}

export const withoutOverrideRow = (data, storeId) => data && { ...data, store_overrides: (data.store_overrides || []).filter(row => row.store_id !== storeId) }
